import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";
import Login from "@/pages/login";
import Informe from "@/pages/Ver-informe";
import SubirVideos from "@/pages/SubirVideos";
import VisualizarVideo from "../pages/VisualizarVideo";
import supInforme from "../pages/supInforme";
import Verpreinforme from "../pages/Verpreinforme";
import MapsGis from "../pages/MapsGis";
import CatastroUD from "../pages/CatastroUD";
import VistaCatastro from "../pages/VistaCatastro";

const routes = [
  {
    path: "/",
    component: Login,
    name: "login"
  },
  {
    path: "/Home",
    component: DashboardLayout,
    name: "Home",
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "/Visualizar",
        name: "VerVideos",
        component: VisualizarVideo
      },
      {
        path: "/Informediario",
        name: "InformeDiario",
        component: supInforme
      },
      {
        path: "/GeoMap",
        name: "Maps",
        component: MapsGis
      },
      {
        path:"/CatastroUD",
        name:"CatastroUD",
        component:CatastroUD
      },
      {
        path:"/VistaCatastro",
        name:"vista Catastro",
        component:VistaCatastro
      },
      {
        path: "/informes",
        name: "informes",
        component: Informe
      },
      {
        path: "/upVideo",
        name: "Videos",
        component: SubirVideos
      },
      {
        path: "/informepreliminar",
        name: "preliminar",
        component: Verpreinforme
      },
      {
        path: "/stats",
        name: "stats",
        component: UserProfile
      },
      {
        path: "/notifications",
        name: "notifications",
        component: Notifications
      },
      {
        path: "/icons",
        name: "icons",
        component: Icons
      },
      {
        path: "/maps",
        name: "maps",
        component: Maps
      },
      {
        path: "/typography",
        name: "typography",
        component: Typography
      },
      {
        path: "/table-list",
        name: "table-list",
        component: TableList
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
